import React from "react";
import { useTranslation } from "react-i18next";
import { usePopup } from "../../../hooks/usePopup";
import SelectTimeLaterModal from "../../MyPage/components/MyBooking/SelectTimeLaterModal";

const ButtonSelectTimeLater: React.FC<{
  booking: BookingState;
  bookingId?: string;
}> = ({ booking, bookingId }) => {
  const popup = usePopup();
  const { t } = useTranslation();

  // const confirmAndRedirect = () => {
  //   popup.close();
  //   navigate("/ticket-check/booking-info/select-ticket");
  // };

  return (
    <div className="select-time-later ml-auto">
      <button
        type="button"
        onClick={() => popup.open()}
        className="ml-auto h-[2.5rem] w-[9.0625rem] rounded-[3.4375rem] bg-[#232323] text-[0.875rem] font-semibold leading-[1.375rem] text-white"
      >
        {t("Select time")}
      </button>

      {popup.isOpen && !!booking?.bookingDetailId && (
        <SelectTimeLaterModal
          product={booking?.product}
          id={booking?.product?.id!}
          slug={booking?.product?.slug!}
          isOpen={popup.isOpen}
          bookingId={bookingId}
          // onSubmit={handleSubmitModal}
          onClose={popup.close}
        />
      )}
    </div>
  );
};

export default ButtonSelectTimeLater;
